import { Injectable } from '@angular/core';

import { setInitialStoreState } from '../../../../../common/utils';
import { Sc3MessageCheckerFacade } from './sc3-message-checker.facade';

@Injectable({
  providedIn: 'root',
})
export class Sc3MessageCheckerGuard  {
  constructor(private sc3MessageCheckerFacade: Sc3MessageCheckerFacade) {}

  canDeactivate(): boolean {
    return setInitialStoreState(this.sc3MessageCheckerFacade);
  }
}
